import React from "react";

interface CardHeaderProps {
  title: string;
  // Shown as "(3 Check-Ins)" next to the title; omit to show no count
  count?: number;
  singular?: string;
  plural?: string;
  // Right-aligned controls, e.g. a blur toggle
  actions?: React.ReactNode;
  // Paging scrolls here rather than to the top of the page
  scrollRef?: React.RefObject<HTMLDivElement>;
}

// The heading row every user-page history card starts with: title, an
// optional record count, and any controls on the right.
const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  count,
  singular = "Item",
  plural = `${singular}s`,
  actions,
  scrollRef,
}) => (
  <div ref={scrollRef} className="mb-4 flex items-center justify-between">
    <div className="flex items-center gap-3">
      <h2 className="text-xl font-bold text-navy-700 dark:text-white">
        {title}
      </h2>
      {count !== undefined && (
        <span className="text-sm text-gray-500 dark:text-gray-400">
          ({count} {count === 1 ? singular : plural})
        </span>
      )}
    </div>
    {actions}
  </div>
);

export default CardHeader;
